import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import type { ViewerManagerVariantsApiExtension } from './types'
import { ViewerManagerVariantsApi, VariantsApiPageHandler } from './viewerManagerVariantsApi'
import { ViewerManagerApiImplementor } from 'thunderbolt-viewer-manager-types'
import { LifeCycle } from '@wix/thunderbolt-symbols'
import { VariantsApiSymbol } from './symbols'

export { VariantsApiSymbol, ViewerManagerVariantsApiExtension }

export const editor: ContainerModuleLoader = (bind) => {
	bind(ViewerManagerApiImplementor, VariantsApiSymbol).to(ViewerManagerVariantsApi)
}

export const editorPage: ContainerModuleLoader = (bind) => {
	bind(LifeCycle.PageWillMountHandler).to(VariantsApiPageHandler)
	bind(LifeCycle.PageDidMountHandler).to(VariantsApiPageHandler)
}
